export default __webpack_public_path__ + "static/media/code.489f34bd.jpg";